import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'CREATE_ACTIVITY_TYPES';

export async function createActivityTypes(userData: Record<string, string>, payload: Record<string, unknown>) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/activity-types/`,
            data: payload,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userData.userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création du type d\'activité',
            error: error
        });
    }
}
